import React from 'react';
import { ColorRadio } from './ColorRadio';

import './styles.css';

export type ColorPickerProps = {
	currentColor?: string;
	colorList: string[];
	clickHandler: (color: string) => void;
	isActive: boolean;
};

export const ColorPicker: React.FC<ColorPickerProps> = ({
	currentColor,
	colorList,
	clickHandler,
	isActive
}) => {
	return (
		<div className="color-picker d-flex">
			{colorList.map((color, key) => (
				<ColorRadio
					key={key}
					currentColor={currentColor}
					color={color}
					onClick={() => clickHandler(color)}
					tabIndex={isActive ? 0 : -1}
				/>
			))}
		</div>
	);
};
